import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import { Badge, Paper, TextField } from "@mui/material";
import { Author } from "../../../manifest/models/author.models";
import { ExperimentBranding } from "../../../manifest/models/branding.models";
import { MenuPage } from "../menu.controller";
import { NavigationBar } from "../navigation-bar.component/navigation-bar.component";
import { OnlineUsersBar } from "../online-users/online-users.component";
import "./desktop-menu.component.css";

export function DesktopTopMenu(props: {
  branding: ExperimentBranding | undefined;
  currentPage: MenuPage;
  notificationCount: number;
  onlineUsers: Author[];
}) {
  if (props.branding == null) {
    return <div className="no-branding"></div>;
  }

  return (
    <Paper className="top-menu-outer" id={`desktop-top-menu-container`}>
      <BrandingBar branding={props.branding} />
      <NavigationBar page={props.currentPage} />
      <OnlineUsersBar onlineUsers={props.onlineUsers} />
      <UserBar notificationCount={props.notificationCount} />
    </Paper>
  );
}

export function UserBar(props: { notificationCount: number }) {
  return (
    <div className="user-bar-container" id={`desktop-top-user-bar-container`}>
      <AddCircleOutlineOutlinedIcon
        className="user-bar-icon"
        id={`desktop-top-user-bar-plus-icon`}
      />
      <ChatOutlinedIcon
        className="user-bar-icon"
        id={`desktop-top-user-bar-chat-icon`}
      />
      <Badge
        badgeContent={props.notificationCount}
        color="primary"
        className="notification-badge-container"
        id={`desktop-top-user-bar-notification-button`}
      >
        <NotificationsActiveOutlinedIcon
          className="notification-icon user-bar-icon"
          id={`desktop-top-user-bar-notification-button`}
        />
      </Badge>
    </div>
  );
}

export function BrandingBar(props: { branding: ExperimentBranding }) {
  return (
    <div
      className="branding-container"
      id={`desktop-top-branding-bar-container`}
    >
      <img
        src={props.branding.icon}
        className="branding-icon"
        id={`desktop-top-branding-bar-icon`}
      />
      <SearchField branding={props.branding} />
    </div>
  );
}

export function SearchField(props: { branding: ExperimentBranding }) {
  return (
    <TextField
      id="desktop-top-branding-bar-search"
      className="search-bar"
      variant="filled"
      placeholder={`Search ${props.branding.name}`}
    />
  );
}
